import {
  MODAL_HIDDEN,
  MODAL_INTERACTION,
  MODAL_DATA_LOADED,
  TABLE_COLUMNS_LOADED,
} from '../actions/constants';
import LayerJoin from '../components/layers/LayerJoin';
import Column from '../util/Column';
import ForeignKey from '../util/ForeignKey';
import ColumnRef from '../util/ColumnRef';
import { JOIN } from '../util/enums/EnumLayers';
import { ALL } from '../util/enums/EnumIncludeType';

const INITIAL_STATE = {
  selected: null, // ForeignKey
  joinType: 'left', // left, right, outer, inner or cross
  includeType: ALL, // EnumIncludeType
  readyForSave: false,

  custom: false, // true if user wants to use custom join wizard
  advanced: false, // true if user wants to change joinType
  joinView: false, // true if user wants to join with a view
  selectedTov: null, // TableRef or ViewRef
  selectedLhs: null, // ColumnName
  selectedRhs: null, // ColumnName
  selectedType: null, // ColumnType
  tableColumns: null, // list of Column (the columns for the selected table)
};

function buildForeignKey(state, lhs, rhs) {
  return {
    ...INITIAL_STATE,
    selected: new ForeignKey(lhs, new ColumnRef(state.selectedTov, rhs.name())),
    readyForSave: true,
    joinType: state.joinType,
  };
}

function interaction(state, payload) {
  switch (payload.section) {
    case 'selectJoin':
      return { ...state, selected: payload.fk, readyForSave: true };
    case 'deselect':
      return {
        ...state,
        selected: null,
        includeType: ALL,
        readyForSave: false,
      };
    case 'joinType': {
      if (
        (state.joinType === 'cross' && payload.newValue !== 'cross') ||
        (state.joinType !== 'cross' && payload.newValue === 'cross')
      ) {
        // switching to/from 'cross join' mode, so reset everything
        return { ...INITIAL_STATE, joinType: payload.newValue };
      }
      return { ...state, joinType: payload.newValue };
    }
    case 'includeType': {
      return { ...state, includeType: payload.newValue };
    }
    case 'custom':
      return {
        ...state,
        custom: true,
        selected: null, // reset
        readyForSave: false, // reset
      };
    case 'advanced':
      return { ...state, advanced: true };
    case 'toggleView':
      return { ...state, joinView: !state.joinView };
    case 'cancelAdvanced':
      return { ...INITIAL_STATE, joinType: state.joinType };
    case 'tableChosen':
      return {
        ...state,
        selectedTov: payload.table,
        tableColumns: null, // reset, so loading bar shows
      };
    case 'deselectTable':
      return { ...state, selectedTov: null };
    case 'selectLhs':
      if (state.selectedRhs) {
        return buildForeignKey(state, payload.columnName, state.selectedRhs);
      }
      return {
        ...state,
        selectedLhs: payload.columnName,
        selectedType: payload.extra,
      };
    case 'selectRhs':
      if (state.selectedLhs) {
        return buildForeignKey(state, state.selectedLhs, payload.columnName);
      }
      return {
        ...state,
        selectedRhs: payload.columnName,
        selectedType: payload.extra,
      };
    case 'deselectLhs': {
      const type = state.selectedRhs ? state.selectedType : null;
      return { ...state, selectedLhs: null, selectedType: type };
    }
    case 'deselectRhs': {
      const type = state.selectedLhs ? state.selectedType : null;
      return { ...state, selectedRhs: null, selectedType: type };
    }
    default:
      return state;
  }
}

const modalJoin = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED:
      if (action.payload.existingLayer instanceof LayerJoin) {
        return {
          ...state,
          selected: action.payload.existingLayer.fk(),
          joinType: action.payload.existingLayer.joinType(),
          includeType: action.payload.existingLayer.includeType(),
          readyForSave: true,
        };
      }
      return state;
    case MODAL_INTERACTION:
      if (action.payload.modalType !== JOIN) {
        return state;
      }
      return interaction(state, action.payload.props);
    case TABLE_COLUMNS_LOADED:
      if (action.payload.table !== state.selectedTov) {
        // data is not for current table
        return state;
      }
      return {
        ...state,
        tableColumns: action.payload.json.map((c) => Column.build(c)),
      };
    default:
      return state;
  }
};

export default modalJoin;
